import React, { useState, useEffect } from "react";
import { useForm,Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import NumberField  from "../../components/admin/NumberField";
import SelectBox from "../../components/admin/SelectBox";
import  defaultConfig  from "../../config/Config";
import { AsyncPaginate } from 'react-select-async-paginate';
import { useDispatch, useSelector } from "react-redux";
import { getList } from "../../slices/ProductsSlice";
import DatePicker from "react-datepicker";
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import { getUserByType } from "../../slices/UserSlice";
import { getAllState } from "../../slices/InitialDataSlice";
import * as Yup from "yup";
import { createScheme, resetApiStatus } from "../../slices/SchemeSlice";
import { Loading } from "../../components/Loading";
import { MessageModel } from "../../components/MessageModel";
import {useNavigate, useLocation} from "react-router-dom"

export function CreateScheme () {
    const locationData = useLocation()
    const dispatch = useDispatch();
    const navigate = useNavigate ();
    const formSchema = Yup.object().shape({
      name: Yup.string().required('Please enter a schema name'),
      schemeType: Yup.string().required('Please select a scheme type'),
      applyOnLocation: Yup.boolean(),
      target: Yup.number()
        .positive()
        .required("Please enter target amount"),
      startDate: Yup.date().required('Start date is required'),
      endDate: Yup.date().required('End date is required'),
      schemeDetails: Yup.string().required("Please select scheme details"),
      product: Yup.string().required("Please select product"),
      stateId: Yup.string().required("Please select state"),
      selectedPartners: Yup
                        .array()
                        .of(Yup.string())
                        .min(1,'Field must have at least 1 items')
                        .when('applyOnLocation', {
                          is: false,
                          then: Yup.array().required("Please select")
                        })

    });
    const todayDate = new Date()

    //
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [selectedUserType, setSelectedUserType] = useState('csa');
    const [selectedProduct, setSelectedProduct] = useState('');
    const [assignedState, setAssignedState] = useState([]);
    const [startDate, setStartDate] = useState(todayDate);
    const [vendorList, setVendorList] = useState([]);
    const [endDate, setEndDate] = useState('');
    const [userTypeLabel, setUserTypeLabel] = useState('CSA');
    const [applyOnLocation, setApplyOnLocation] = useState(false)

    //
    const allStates = useSelector( (state) => state.initialData.StateList );
    const authData = useSelector( (state) => state.auth.authData );
    const { usersByType } = useSelector((state) => state.users);
    const message = useSelector((state)=> state?.scheme?.message);
    const success = useSelector((state)=> state.scheme.success);
    const loading = useSelector((state)=> state.scheme.loading);
    console.log(success, message)
    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        control, 
        watch,
        formState: { errors },
    } = useForm({
        mode: "onBlur",
        resolver: yupResolver(formSchema),
    });
    console.log(watch())
    console.log(errors)
    async function loadProducts( search, loadedOptions, { page } ) {
      if(!requestInProgress){
          setRequestInProgress(true)
          const {meta, payload} = await dispatch(getList({data : {pageLength:defaultConfig.defaultLimit, page: page, searchString: search}}))
          let productList = []
          if(meta.requestStatus === "fulfilled"){
              setRequestInProgress(false)
              productList = payload?.docs.map(({_id: productIds, name, price}) => { return { label:`${name})` , value : productIds, price } })
          }
          
          return {
              options: productList,
              hasMore: productList?.length > 0? true : false,
              additional: {
                  page: page + 1
              }
          };

      }else  {
          return {
              options:[],
              hasMore:true,
              additional: {
                  page: page
              }
          };
      }
    }

    function findAssignedState(allStates, assignedStateIds) {
      if(!assignedStateIds || (assignedStateIds.length === 0)) {
        return allStates;
      }
      return allStates.filter( (state) => assignedStateIds.indexOf(state._id) > -1 );
    }

    useEffect(() => { 
      dispatch(getAllState());
    }, [dispatch])

    useEffect( () => {
      const assignedStateIds = authData.user.assignState;
      const states = findAssignedState(allStates, assignedStateIds);
      setAssignedState( () => {
          return  ToSelectOption(
            states,
            {
              value:"_id",
              label: 'name'
            }
          )
      } );
    }, [allStates, authData])

    useEffect (() => { 
      let list = []
      if(typeof usersByType !== "undefined"){
        list = usersByType?.map( ({userDetails, _id: userID}) => {
          return {
              value: userID,
              label: userDetails.shopName
          }
        })
      }
      setVendorList(list)
    },[setVendorList, usersByType]);

    function getVendor(stateId, callback) {
      const hasSelectedUser = defaultConfig?.dashboardUserType.find( ({value}) => value === selectedUserType )
      setValue('orderFrom', null)
      if(stateId && hasSelectedUser) {
        dispatch(getUserByType({userType: selectedUserType, stateId: stateId}))
      }

      if(typeof callback !== "undefined") {
        callback(stateId)
      }
    }

    function onChangeSchemeApplyOn(event) {
        const stateId = getValues('assignedState');
        setSelectedUserType(event.target.value)
        const selectedUser = defaultConfig?.dashboardUserType.find( ({value}) => value === event.target.value );
        setUserTypeLabel(selectedUser.label)
        getVendor(stateId)
        
    }

    function onSubmit(dataToSubmit) {
      dispatch(createScheme(dataToSubmit))
    }

    function onCancel() {
      const queryString  = locationData.state? new URLSearchParams(locationData.state).toString(): null
      let url = '/scheme'
      if(queryString) {
        url = url  + `?${queryString}`
      }
      navigate(url)
    }

    return (
      <div className="row">
        <div className="col-md-12 col-lg-12">
          <div className="card payment-card">
            <div className="card-header">
              <h4 className="card-title">{ "Create Scheme"}</h4>
            </div>
            <hr/>
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <input {...register("id")} type="hidden" />
                <div className="formDiv">
                  <div className="row">
                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`input-label ${errors.title && "error"}`}>
                          Name
                        </label>
                        <input 
                          {...register("name")}
                          type="text"
                          className={`input-txt form-control ${
                            errors.name?.message && "error"
                          }`}
                          placeholder="Scheme Title"
                        />
                        {errors.name && (
                          <FormError message={errors.name.message} />
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`input-label ${errors.schemeType && "error"}`}>
                          Scheme Type
                        </label>
                        <Controller
                          control={control}
                          name="schemeType"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={defaultConfig.schemeType}
                              isClearable={true}
                              onChange={(opt) => onChange(opt?.value)}
                              value={defaultConfig.schemeType.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        
                        {errors.schemeType && (
                          <FormError message={errors.schemeType.message} />
                        )}
                      </div>
                    </div>
                    
                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`input-label ${errors.target && "error"}`}
                        >
                          Target (In INR)
                        </label>
                        
                        <NumberField 
                          placeholder="Product Price" 
                          setValue = { setValue } 
                          control = {control}
                          name = {`target`} 
                          className='input-txt form-control'
                          value={`${0}`} 
                        />  
                        {errors.target && (
                          <FormError message={errors.target.message} />
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="form-group mb-0">
                        <label
                          htmlFor="card-number"
                          className={`d-block ${errors?.applyOn?.message && "error"}`}
                        >
                          Scheme Apply By
                        </label>
                        <div className="col-sm-2 form-check form-check-inline pr-0">
                          <input 
                            className="form-check-input" 
                            type="radio" 
                            {...register('partnerType')} 
                            value="csa"
                            id="csa"
                            defaultChecked
                            onChange={onChangeSchemeApplyOn}
                          />
                          <label className="form-check-label mt-2" htmlFor="csa">CSA</label>
                        </div>
                        <div className="col-sm-4 form-check form-check-inline pr-0 mr-0">
                          <input 
                            className="form-check-input" 
                            type="radio" 
                            {...register('partnerType')} 
                            value="superStockists"
                            id="ss"
                            onChange={onChangeSchemeApplyOn}
                          />
                          <label className="form-check-label mt-2" htmlFor="ss">Super Stokists</label>
                        </div>
                        <div className="col-sm-3 form-check form-check-inline pr-0">
                        <input 
                            className="form-check-input" 
                            type="radio" 
                            {...register('partnerType')} 
                            value="distributors"
                            id="distributors"
                            onChange={onChangeSchemeApplyOn}
                          />
                          <label className="form-check-label mt-2" htmlFor="distributors">Distributors</label>
                        </div>
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="form-group mb-0">
                        <label
                          htmlFor="card-number"
                          className={`d-block ${errors?.applyOn?.message && "error"}`}>
                          Scheme Apply On Location Only
                        </label>
                        <div className="col-sm-12 form-check form-check-inline pr-0">
                          <input 
                            className="form-check-input" 
                            type="checkbox" 
                            {...register('applyOnLocation')} 
                            id="applyOnLocation"
                            onChange={(event) => setApplyOnLocation(event.target.checked) }
                          />
                          <label className="form-check-label mt-2" htmlFor="applyOnLocation">Apply On Location</label>
                        </div>
                      </div>
                    </div>

                    <div className="col-2">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`d-block ${errors.startDate && "error"}`}
                        >
                          Start Date
                        </label>
                        <Controller
                          control={control}
                          name="startDate"
                          defaultValue={startDate}
                          render={({ field: { value, onChange } }) => (
                              <DatePicker 
                                showIcon
                                showMonthDropdown 
                                showYearDropdown 
                                
                                icon="fa fa-calendar"
                                placeholderText="Start Date"
                                className={`input-txt form-control ${
                                  errors.startDate && "error"
                                }`}
                                isClearable
                                dateFormat="MMM d, yyyy"
                                selected={startDate} 
                                minDate={todayDate}
                                onChange={(date) => {
                                  setStartDate(date)
                                  setEndDate('')
                                  setValue('endDate', undefined)
                                  onChange(date)
                                  if(!date) {
                                    setValue('startDate', undefined)
                                  }
                                }  }
                              />
                            )}
                        />
                        {errors.startDate && (
                          <FormError message={errors.startDate.message} />
                        )}
                      </div>
                    </div>

                    <div className="col-2">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`d-block ${errors?.endDate?.message && "error"}`}>
                          End Date
                        </label>
                        <Controller
                          control={control}
                          name="endDate"
                          defaultValue={endDate}
                          render={({ field: { value, onChange } }) => (
                                <DatePicker 
                                  showIcon
                                  icon="fa fa-calendar"
                                  showMonthDropdown 
                                  showYearDropdown 
                                  placeholderText="End Date"
                                  className={`input-txt form-control ${
                                    errors.startDate && "error"
                                  }`}
                                  isClearable
                                  dateFormat="MMM d, yyyy"
                                  selected={endDate} 
                                  minDate={startDate}
                                  onChange={(date) => {
                                      console.log(date)
                                      setEndDate(date); 
                                      if(!date) {
                                        setValue('endDate', undefined)
                                      }
                                      
                                      onChange(date)
                                    } 
                                  }
                                />)}
                        />
                                  
                        {errors.endDate && (
                          <FormError message={errors.endDate.message} />
                        )}
                      </div>
                    </div>
                    
                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`d-block ${errors.statue && "error"}`}
                        >
                          Status
                        </label>
                        <Controller
                          control={control}
                          name="status"
                          value={defaultConfig.status[0]["value"]}
                          defaultValue={defaultConfig.status[0]["value"]}
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={defaultConfig.status}
                              isClearable={true}
                              onChange={(opt) => onChange(opt?.value)}
                              value={defaultConfig.status.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.status && (
                          <FormError message={errors.status.message} />
                        )}
                      </div>
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`input-label ${errors.product && "error"}`}
                        >
                          Product
                        </label>
                        <Controller
                          control={control}
                          name={`product`}
                          render={({ field: { value, onChange } }) => (
                              <AsyncPaginate
                                  //value={selectedProduct}
                                  closeMenuOnSelect={false}
                                  loadOptions={loadProducts}
                                  onChange={ (e)=>{  
                                      setSelectedProduct(e.label)
                                      onChange(e.value) 
                                  } }
                                  additional={{
                                      page: 1,
                                  }}
                              />
                          )}
                        />
                        {errors.product && (
                          <FormError message={errors.product.message} />
                        )}
                      </div>
                    </div>

                    <div className="col-8">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="card-number"
                          className={`d-block ${errors?.schemeDetails?.message && "error"}`}
                        >
                          Scheme Details
                        </label>
                        <textarea
                        {...register("schemeDetails")}
                        type="text"
                        placeholder="Scheme Details"
                        rows={8}
                        style={{ "resize": "none" }}
                        className={`form-control ${
                          errors.schemeDetails?.message && "error"
                        }`}
                      />      
                        {errors.schemeDetails && (
                          <FormError message={errors.schemeDetails.message} />
                        )}
                      </div>
                    </div>
                    
                    <div className="col-sm-12">
                      <div className="row">
                        <div className="col-4">
                          <div className="form-group mb-3">
                            <label
                              htmlFor="card-number"
                              className={`input-label ${errors.vendorType && "error"}`}
                            >
                              States
                            </label>
                            <Controller
                              control={control}
                              name="stateId"
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={assignedState}
                                  isClearable={true}
                                  onChange={(opt) => getVendor(opt?.value, onChange)}
                                  value={assignedState?.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                            
                            {errors.assignedState && (
                              <FormError message={errors.assignedState.message} />
                            )}
                          </div>
                        </div>  
                          {
                            !applyOnLocation? <div className="col-4">
                            <div className="form-group mb-3">
                              <label
                                htmlFor="card-number"
                                className={`input-label ${errors.selectedPartners && "error"}`}
                              >
                                {userTypeLabel} &nbsp;
                              </label>
                              <Controller
                                control={control}
                                name="selectedPartners"
                                render={({ field: { value, onChange } }) => (
                                  <SelectBox
                                    closeMenuOnSelect={false}
                                    options={vendorList}
                                    isMulti
                                    isClearable={true}
                                    onChange={(opt) => {
                                      const ids = opt.map( ({value}) => value )
                                      onChange(ids)
                                    }}
                                    value={vendorList?.filter(
                                      (option) => value?.indexOf(option.value) >= 0
                                    )}
                                  />
                                )}
                              />
                              {errors.selectedPartners && (
                                <FormError message={errors.selectedPartners.message} />
                              )}
                            </div>
                          </div> : '' 
                          }     
                        
                      </div>
                    </div>
                  </div>

                </div>
                <div className="col-12 mt-5 mb-3 text-right">
                  <button type="submit" className="btn btn-outline-success btn-lg mx-2">
                    Submit
                  </button>
                  <button type="button" onClick={onCancel} className="btn btn-outline-danger btn-lg mx-2">
                    Cancel
                  </button>
                </div>
              </form>
            </div>
            
          </div>
        </div>
        {loading === true?<Loading/>:"" }
        {message? 
          <MessageModel
            btnEvent={ ()=>{
              dispatch(resetApiStatus()) 
              if(success) 
                navigate("/scheme")
            } }
            success={success}
            message={message}
          />
        :""}
      </div>
    );

}